var DeployerProductLoader = class {
    static loadedProducts = {};
    static load(productHandle) {
      if (!productHandle) {
        return;
      }
      if (this.loadedProducts[productHandle]) {
        return this.loadedProducts[productHandle];
      }
      this.loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
        const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
        if (response.ok) {
          const responseAsJson = await response.json();
          resolve(responseAsJson);
        } else {
          reject(`
            Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
            switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
            to "active".
          `);
        }
      });
      return this.loadedProducts[productHandle];
    }
  };
class TdBundles extends HTMLElement {
    constructor(){
        super();
        this.bundlesVariantsSelects = this.querySelectorAll('.td-bundle-variant--selects');
        this.bundlesVariants = this.querySelectorAll('.td-bundle-variant');
        this.bundlesInputs = this.querySelectorAll('.td-bundle-input');
        this.addToCart = this.closest('.product-info').querySelector('button[type=submit]')
        this.addToCartContent =  this.closest('.product-info').querySelector('.button-content-hidden');
        this.priceList = document.querySelector('price-list');
    }

    connectedCallback(){
        if(typeof Weglot !== 'undefined'){
          Weglot.on("languageChanged", this.weglotLanguageChange.bind(this));
        }
        this.bundlesVariantsSelects.forEach((select) => {
            this.getMatchingVariant(select);

            select.addEventListener('change', (e) => {
                this.getMatchingVariant(e.currentTarget);
            });
        });

        this.bundlesInputs.forEach((input) => {
          if(input.checked){
            window.addEventListener('load', () => {
            this.updatePriceInAtc(input);
            });
            //this.updateMainPriceList(input);
          }
            input.addEventListener('change', (e) => {
                if(!e.currentTarget.checked);
                //this.updateMainPriceList(e.currentTarget);
                this.updatePriceInAtc(e.currentTarget)
            });
        });

        document.addEventListener('variant:change', this.synchronizeVariants.bind(this));
    }

    weglotLanguageChange(){
      this.bundlesInputs.forEach((input) => {
        if(input.checked){
          this.updatePriceInAtc(input);
        }
      });
    }
    
    /*updateMainPriceList(input){
      const priceContainer = this.priceList.querySelector('sale-price');
      const compareAtPriceContainer = this.priceList.querySelector('compare-at-price');
      priceContainer.innerText = input.dataset.price;
      if(!compareAtPriceContainer) return;
      compareAtPriceContainer.innerText = input.dataset.compareAtPrice;
    }*/

    updatePriceInAtc(input){
      this.addToCart.querySelector('.add-cart-text').innerHTML =`${this.addToCartContent.innerText} • <span class="atc-button-price">${input.dataset.price}</span> <s class="atc-button-compare-at-price">${input.dataset.compareAtPrice == input.dataset.price ? '' : input.dataset.compareAtPrice}</s>`

      console.log(input.dataset.price)
      var pricetobe = parseInt(input.dataset.price.replace(',','').replace('€','').trim());
      //console.log(pricetobe)
      $(document).find('[data-key="credit-promotion-badge"]').attr("data-purchase-amount", pricetobe).addClass('changed');
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
      
    }

    async getMatchingVariant(target) {
        this.product = await DeployerProductLoader.load(this.getAttribute("handle"));
        // Find the parent td-bundle-variant element of the changed select box
        let parentBundleVariant = target.closest('.td-bundle-variant');
        // Gather all the option values from this bundle variant
        let selectedOptions = [];
        parentBundleVariant.querySelectorAll('.td-bundle-variant--select').forEach(select => {
            selectedOptions.push(select.value);
        });
        // Find a matching variant based on the selected option values
      console.log(this.product.variants)
        let matchingVariant = this.product.variants.find(variant => {
            return selectedOptions.every((value, index) => {
                return variant[`option${index + 1}`] === value;
            });
        });
        if(matchingVariant) {
            parentBundleVariant.dataset.variantId = matchingVariant.id;
            return matchingVariant;
        } else {
            console.warn('No matching variant found.');
        }
    }

    getSelectedVariantIds() {
        let variantIds = [];
        const checkedInput = this.querySelector('.td-bundle-input:checked');
        const BundleWrapper = checkedInput.closest('.td-bundle-wrapper');
        const bundleVariants = BundleWrapper.querySelectorAll('.td-bundle-variant');
        
        bundleVariants.forEach((variant) => {
            // if variantIds already contains the variantId, increase the quantity else add the variantId to the array with quantity 1
            if(variantIds.some(variantId => variantId.id === variant.dataset.variantId)) {
                variantIds.find(variantId => variantId.id === variant.dataset.variantId).quantity += 1;
            } else {
                variantIds.push({
                    id: variant.dataset.variantId,
                    quantity: 1
                });
            }
        });
        return variantIds;
    }

    synchronizeVariants(e){
      const selectedVariant = e.detail.variant;
      this.bundlesVariants.forEach((variant) => {
        variant.dataset.variantId = selectedVariant.id;
      });
     this.bundlesVariantsSelects.forEach((selects) => {
        selects.querySelectorAll('select').forEach((select) => {
          const selectVariant = this.product.variants.find(variant => variant.id === selectedVariant.id);
          if (selectVariant) {
            const optionValue = selectVariant[`option${select.dataset.optionPosition}`];
            select.value = optionValue;
        }
        });
     })
     this.bundlesInputs.forEach((input) => {
      if(input.checked){
        //this.updateMainPriceList(input);
        this.updatePriceInAtc(input);
      }
    });
    }
}
customElements.define('td-bundles', TdBundles);